import { useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, Package, Inbox, Mail, LogOut, Home } from "lucide-react";
import { api } from "@/lib/api";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/prodotti", label: "Prodotti", icon: Package },
  { to: "/admin/preventivi", label: "Preventivi", icon: Inbox },
  { to: "/admin/prove", label: "Prove a casa", icon: Home },
  { to: "/admin/iscritti", label: "Newsletter", icon: Mail },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const email = localStorage.getItem("aeras_admin_email") ?? "admin";

  useEffect(() => {
    // verify token
    api.get("/auth/me").catch(() => nav("/admin/login", { replace: true }));
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("aeras_admin_token");
    localStorage.removeItem("aeras_admin_email");
    nav("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-white text-[#0a0a0a] flex" data-testid="admin-layout">
      <aside className="w-64 border-r border-[#e4e4e7] p-6 flex flex-col shrink-0 sticky top-0 h-screen">
        <div className="flex items-center gap-3 mb-16">
          <span className="font-display text-2xl tracking-tighter">
            aér<span className="text-[#007A8A]">à</span>s
          </span>
          <span className="font-mono text-[10px] tracking-[0.3em] text-[#52525b]">
            CONSOLE
          </span>
        </div>

        <nav className="flex-1 space-y-1">
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 border-l-2 transition-colors font-body text-sm ${
                  isActive
                    ? "border-[#007A8A] text-[#0a0a0a] bg-[#f4f4f5]"
                    : "border-transparent text-[#3f3f46] hover:text-[#0a0a0a] hover:bg-[#f4f4f5]"
                }`
              }
            >
              <Icon size={16} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="pt-6 border-t border-[#e4e4e7]">
          <div className="font-mono text-[10px] tracking-widest uppercase text-[#52525b] mb-2">
            Loggato come
          </div>
          <div className="font-body text-sm text-[#0a0a0a] mb-4 break-all">{email}</div>
          <button
            onClick={logout}
            className="w-full text-left flex items-center gap-2 py-2 text-[#3f3f46] hover:text-[#FF4D00] transition-colors font-mono text-[11px] tracking-widest uppercase"
            data-testid="admin-logout"
          >
            <LogOut size={14} /> Esci
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
